export const GRAFTING_RESULT = {
    NOT_DONE: 0,
    DONE: 1,
    PENDING: 2,
};